/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_YesInputs */

const en_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_dialogue_list_export_precheck_yes = /** @type {(inputs: Dialogue_List_Export_Precheck_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Dialogue_List_Export_Precheck_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_yes = /** @type {((inputs?: Dialogue_List_Export_Precheck_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_precheck_yes(inputs)
	if (locale === "de") return de_dialogue_list_export_precheck_yes(inputs)
	if (locale === "it") return it_dialogue_list_export_precheck_yes(inputs)
	if (locale === "ru") return ru_dialogue_list_export_precheck_yes(inputs)
	if (locale === "es") return es_dialogue_list_export_precheck_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_precheck_yes(inputs)
	if (locale === "ja") return ja_dialogue_list_export_precheck_yes(inputs)
	if (locale === "hi") return hi_dialogue_list_export_precheck_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_precheck_yes(inputs)
	return en_dialogue_list_export_precheck_yes(inputs)
});